import React, { useContext, useEffect, useRef, useState } from 'react';
import { SettingsBannerContext } from '../../contexts/SettingsBannerContext';
import { MasterBannerContext } from '../../contexts/MasterBannerContext';
import Box from '@mui/material/Box';
import Slider from '@material-ui/core/Slider';
import { AuthValidatorContext } from '../../contexts/auth';
import './index.css';
import CryptoJS from 'crypto-js'; 
import { GetArrayTxtIndex } from '../../helpers/fileManager';
import { ConvertStepActive } from '../../helpers/BuildActiveStep';
import { SaveReanimateFile, DownloadPackHTML, DownloadPackEstatico, DownloadPackDynamic } from '../../helpers/fileManager.js'
import { useAuth } from '../../hooks/useAuth'
import { BannerJson } from '../../helpers/buildBanner';
import DownloadIcon from '@mui/icons-material/Download';
import ReplayIcon from '@mui/icons-material/Replay';
import AnimationIcon from '@mui/icons-material/Animation';
import CodeIcon from '@mui/icons-material/Code';
import CropOriginalIcon from '@mui/icons-material/CropOriginal';
import VideocamIcon from '@mui/icons-material/Videocam';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import useLocalStorage from "../../hooks/useLocalStorage";
import { Copilot } from '../IA/copilot/index.js';
import { getBalance } from '../../services/auth.js';
import { verifyAnimation } from '../../helpers/buildVideo';
import { ConvertBannerDynamic } from '../../helpers/exportBanner.js'
import Switch from '@mui/material/Switch';

function Stage() {
  const dynamicEmails = [
    "luiz.miller@pointmedia.com.br",
    "gustavo.melo@pointmedia.com.br",
    "marcos.antonio@pointmedia.com.br",
    "leonardo@pointmedia.com.br"
  ];
  const { setReload, reload, setError, setLoading, stepActive, setFullScreenLeft, setVideoModal, fullScreenRight, setFullScreenRight, isIABFormat, setIsIABFormat, isIABWeight, setIsIABWeight, backupFormat, listaBanners } = useContext(SettingsBannerContext);
  const { setMaster, master, listFonts, setListFonts, assets } = useContext(MasterBannerContext);
  const [ zoom, setZoom ] = useState(1);
  const [ zoomFit, setZoomFit ] = useState(true);
  const { setAuth } = useContext(AuthValidatorContext);
  const refIframeMaster = useRef(null);
  const refInput = useRef(null);
  const { recordHash } = useAuth();
  const [ tokenLocalStorage, setTokenLocalStorage ] = useLocalStorage('@login-mastermotion/token', null);
  const [ userLocalStorage, setUserLocalStorage ] = useLocalStorage('@login-mastermotion/user', null);
  const dynamic = window.location.href.includes("dynamic") || window.location.href.includes("localhost") || (userLocalStorage && userLocalStorage.email && dynamicEmails.includes(userLocalStorage.email)) ? true : false;
  const [ modalDynamic, setModalDynamic ] = useState("");
  const [ modalFonts, setModalFonts ] = useState(false);
  const [ listDynamic, setListDynamic ] = useState([]);

  useEffect(()=>{
     Reload()
  },[stepActive])

  useEffect(()=>{
     setListDynamic([]);
  },[modalDynamic])

  async function LoadIframe() {
    if (master && master.html) {
      var html = master.html;
      if (master.audio && master.audio.b64) {
        html = html.replace(`document.getElementById("sound-on").addEventListener("click", stopAudio)`, "");
        html = html.replace(`document.getElementById("sound-off").addEventListener("click", playAudio)`, "");
        html += 
        `
          <script type="text/javascript">
            document.getElementById("sound-on").style.display = 'block';
            document.getElementById("sound-off").style.display = 'none';          
            var audioTagiframe = document.getElementById("player");          
            setTimeout(function(){
              audioTagiframe.play();
            }, ${master.audio ? master.audio.delay * 1000 : 0});
            
          </script>
        `
      }
      if (master.audioIA && master.audioIA.b64) {
        html = html.replace(`document.getElementById("sound-on").addEventListener("click", stopAudioIA)`, "");
        html = html.replace(`document.getElementById("sound-off").addEventListener("click", playAudioIA)`, "");
        html += 
        `
          <script type="text/javascript">
            document.getElementById("sound-on").style.display = 'block';
            document.getElementById("sound-off").style.display = 'none';          
            var audioTagiframeIA = document.getElementById("player-IA");          
            setTimeout(function(){
              audioTagiframeIA.play();
            }, ${master.audioIA ? master.audioIA.delay * 1000 : 0});
         
          </script>
        `
      }
      refIframeMaster.current.onload = async () => {
        const iframe = refIframeMaster.current.contentDocument;
        // refIframeMaster.current.src = "about:blank";
        refIframeMaster.current.style.width = master.width + "px";
        refIframeMaster.current.style.height = master.height + "px";
        if (stepActive !== null) {
        let iframeStepActive =  stepActive === null ? null : await ConvertStepActive(master, stepActive.stepPosition, stepActive.tillTheEnd);
          iframe.open();
          iframe.write(iframeStepActive);
          iframe.close();
        } else {
          iframe.open();
          iframe.write(html);
          iframe.close();
        }
      };
    }
  }

  function Reload() {
    if (refIframeMaster.current) {
      refIframeMaster.current.src = "about:blank";
      LoadIframe();
    }
  }
  if (reload) Reload();

  function ChangeZoom(evt) {
    try {
      var el = document.getElementById('stage-banner-id');
      var width = el.offsetWidth;
      var height = el.offsetHeight;
      var bannerWidth = (zoom / 100) * master.width;
      var bannerHeight= (zoom / 100) * master.height;
      var fit = false;
      if (width > bannerWidth && height > bannerHeight) {
        fit = true;
      }
      setZoomFit(fit);
      setZoom(evt);
    } catch (error) {}
  }
  
  const [elements, setElements] = useState([]);
  let steps = 0;

  useEffect(() => {
    steps = master.elements[master.elements.length - 1].step;
    let copyElements = JSON.parse(JSON.stringify(master.elements.filter(x => x.fixo || x.stepout > steps)));
    copyElements.forEach(element => {
      if (element.parent) {
        copyElements.forEach(parent => {
          if (parent.id === element.parent) {
            element.properties.left += parent.properties.left;
            element.properties.top += parent.properties.top;
          }
        });
      }
      setElements(copyElements);
    });
  }, [master.elements]);


  function carregarSeed() {
    try {
      setLoading({show: true, progress: false});
      const file = refInput.current.files[0];
      const fr = new FileReader();
      fr.onload = ({ currentTarget }) => {    
        var masterCopy = JSON.parse(JSON.stringify(master));
        var bytes = CryptoJS.AES.decrypt(currentTarget.result, '%G@g$#@FDcxzHJd234@#%');    
        var file = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        var masterSeed = JSON.parse(GetArrayTxtIndex("<master>", "</master>", file)[0]);
        const notFound = [];
        masterCopy.elements.forEach(element => {
          var changed = false;
          masterSeed.elements.forEach(seed => {
            if (element.id === seed.id) {
              element.animation = seed.animation;
              element.fixo = seed.fixo;
              element.stepout = seed.stepout;
              element.out = seed.out;
              element.loop = seed.loop;
              element.properties.zIndex = seed.properties.zIndex;
              changed = true;
            }
          });
          if (!changed) notFound.push(element.id);
        });
        masterCopy.customKeyframe = masterSeed.customKeyframe;
        if (notFound.length) 
        {
          setError(
            {
              mensagem: "Elemento(s) não encontrado(s) no seed:",
              lista: notFound,
              show: true
            }
          );
        }
        setMaster(masterCopy);
        setReload(true);
        setLoading({show: false, progress: false});
      }
      fr.readAsText(file);
    } catch (error) {
      setError(
        {
          mensagem: error,
          show: true
        }
      );
      setLoading({show: false, progress: false});
    }
  }

  async function SaveFile(type) {
    setLoading({show: true, progress: false});
    var copyMaster = JSON.parse(JSON.stringify(master));
    var verify = verifyAnimation(copyMaster);
    if (verify.erros.length > 0) {
      var erro = "";
      for (var i = 0; i < verify.erros.length; i++) {
        erro += "[" + verify.erros[i] + "] ";
      }
      setError(
        {
          mensagem: "Keyframe inválido - Utilizar padrão: animation: animation-name 1.4s forwards;",
          lista: [erro],
          show: true
        }
      )
      setLoading({show: false, progress: false});
      return;
    }
    var res = null;
    if (type === "reanimate") {
      await SaveReanimateFile(master, assets, listaBanners);
      res = { allowed_access: true };
    }
    else if (type === "html") {
      res = await recordHash(await BannerJson(master, "html"));
      if (res) await DownloadPackHTML(master, assets, listaBanners, backupFormat);
    }
    else if (type === "estatico") {
      res = await recordHash(await BannerJson(master, "estatico"));
      if (res) await DownloadPackEstatico(master, assets, listaBanners, backupFormat);
    }
    else if (type === "dynamic") {
      await DownloadPackDynamic(master, listFonts);
      res = { allowed_access: true };
    }    

    if (!res.allowed_access) {
      setTokenLocalStorage(null);
      setUserLocalStorage(null);
      window.location.replace('https://www.reanimateads.com.br')
    } else {
      console.log('sem redirecionar')
    }
    setLoading({show: false, progress: false});
  }

  const [isWindowUpOpen, setIsWindowUpOpen] = useState(false);
  const [isWindowDownOpen, setIsWindowDownOpen] = useState(false);
  const windowRef = useRef(null);

  const handleWindowUp = () => {
    setIsWindowUpOpen(!isWindowUpOpen)
  };

  const handleWindowDown = () => {
    setIsWindowDownOpen(!isWindowDownOpen)
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (windowRef.current && !windowRef.current.contains(event.target)) {
        setIsWindowUpOpen(false)
        setIsWindowDownOpen(false)
      }
    };

      document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
  }, [] });

  const handleClickUpdatePSD = () => {
    document.getElementById('file-dropzone-updatepsd').click();
    setIsWindowUpOpen(false);
  };

  const handleClickLoadSeed = () => {
    refInput.current.click();
    setIsWindowUpOpen(false);
  };

  const handleClickDownloadRean = () => {
    SaveFile("reanimate");
    setIsWindowDownOpen(false);
  };

  const handleClickDownloadHTML = async () => {
    var balance = await getBalance(tokenLocalStorage);
    if (balance > 0) SaveFile("html");
    else {        
      setError(
        {
          mensagem: "Você não tem mais peças disponíveis",
          lista: [],
          show: true
        }
      );
    }
    setIsWindowDownOpen(false);
  };

  const handleClickDownloadImg = async () => {
    var balance = await getBalance(tokenLocalStorage);
    if (balance > 0) SaveFile("estatico");
    else {        
      setError(
        {
          mensagem: "Você não tem mais peças disponíveis",
          lista: [],
          show: true
        }
      );
    }
    setIsWindowDownOpen(false);
  };

  const handleClickDownloadVid = async () => {
    var balance = await getBalance(tokenLocalStorage);
    if (balance > 0) setVideoModal(true);
    else {        
      setVideoModal(false);
      setError(
        {
          mensagem: "Você não tem mais peças disponíveis",
          lista: [],
          show: true
        }
      );
    }      
    setIsWindowDownOpen(false);
  };

  const handleClickDownloadDynamic = () => {
    SaveFile("dynamic");
    // setIsWindowDownOpen(false);
    // setModalDynamic("");
    // setListDynamic([]);
  };

  const handleCheckDynamic = (element) => {
    var copyMaster = JSON.parse(JSON.stringify(master));
    const index = copyMaster.elements.findIndex(el => el.id === element.id);
    if (index > -1) {
      let el = copyMaster.elements[index];
      el.dynamic = !el.dynamic;
      setMaster(copyMaster);
    }
  }
  

  const extensionToMimeFormat = {
    ttf: { mime: 'font/ttf', format: 'truetype' },
    otf: { mime: 'font/otf', format: 'opentype' },
    woff: { mime: 'font/woff', format: 'woff' },
    woff2: { mime: 'font/woff2', format: 'woff2' },
    eot: { mime: 'application/vnd.ms-fontobject', format: 'embedded-opentype' },
  };

  async function handleAddFonts() {
    setLoading({show: true, progress: 0});
    await new Promise(resolve => setTimeout(resolve, 100));
    const files = Array.from(document.getElementById('id-add-fonts').files);
    let copyListFonts = JSON.parse(JSON.stringify(listFonts));

    for (let i = 0; i < files.length; i++) {
    await new Promise(resolve => setTimeout(resolve, 100));
      const file = files[i];
      const p = Math.floor((i + 1) * 100 / files.length);
      setLoading({show: true, progress: p});
      if (!file) continue;

      const ext = file.name.split('.').pop().toLowerCase();
      const mimeAndFormat = extensionToMimeFormat[ext];

      if (!mimeAndFormat) {
        alert('Tipo de fonte não suportado.');
        continue;
      }

      const reader = new FileReader();
      
      const fileLoaded = new Promise((resolve) => {
        reader.onload = () => resolve(reader.result);
      });

      reader.readAsDataURL(file);
      const result = await fileLoaded;
      const base64Str = result.split(',')[1];
      copyListFonts.push({
        name: file.name.replace(/\.[^/.]+$/, ""),
        b64: base64Str,
        type: ext
      });
    }
    console.log(copyListFonts);
    setListFonts(copyListFonts);
    setLoading({show: false, progress: false});
  }

  function handleRemoveFont(index) {
    let copy = [...listFonts];
    copy.splice(index, 1);
    setListFonts(copy);
  }

  function handleChangeFont(element, indexFont) {
    if (!element.properties.text) return;
    let copyMaster = JSON.parse(JSON.stringify(master));
    const idx = copyMaster.elements.findIndex(el => el.id === element.id);
    let el = copyMaster.elements[idx];
    if (indexFont === null) {
      el.properties.text.font = {};
    } else {
      el.properties.text.font = JSON.parse(JSON.stringify(listFonts[indexFont]));
    }
    setMaster(copyMaster);
  }

  const [ active, setActive ] = useState(null);
  const [ activeElement, setActiveElement ] = useState(null);
  const [ activeOver, setActiveOver ] = useState('');
  const [ background, setBackground ] = useState(false)
  const [ activeTranslate, setActiveTranslate ] = useState(null);

  function handleChangeContain(evt) {
    let copyMaster = JSON.parse(JSON.stringify(master));
    let index = copyMaster.elements.findIndex(x => x.id === activeElement.id);
    if (index > -1) {
      copyMaster.elements[index].properties.safearea.contain = evt.target.checked;
      setMaster(copyMaster);
    }
  }

  function handleChangeAlign(direction, align) {
    let copyMaster = JSON.parse(JSON.stringify(master));
    let index = copyMaster.elements.findIndex(x => x.id === activeElement.id);
    if (index > -1) {
      copyMaster.elements[index].properties.safearea.align[direction] = align;
      setActiveElement(copyMaster.elements[index]);
      setMaster(copyMaster);
    }
  }

  function handleTranslate(e, element) {
    setActiveElement(element);
    if (activeTranslate) {
      setActiveTranslate(null);
    } else {
      let masterCopy = master.elements.filter(x => x.dynamic === true);
      masterCopy.forEach(el => {        
        document.getElementById(`id-safearea-${el.id}`).style.pointerEvents = 'none';
      });
      setActiveTranslate({
        element: element,
        pos: {
          x: e.clientX, y: e.clientY
        },
        top: parseInt(document.getElementById(`id-safearea-${element.id}`).style.top.replaceAll('px', '')),
        left: parseInt(document.getElementById(`id-safearea-${element.id}`).style.left.replaceAll('px', '')),
        safearea : element.properties.safearea
      });
    }
  }

  function handleResize(e, element) {
    setActiveElement(element)
    if (active) {
      setActive(null);
    } else if (activeTranslate === null) {
      let masterCopy = master.elements.filter(x => x.dynamic === true);
      masterCopy.forEach(el => {        
        document.getElementById(`id-safearea-${el.id}`).style.pointerEvents = 'none';
      });
      setActive({
        element: element,
        pos: {
          x: e.clientX, y: e.clientY
        },
        width: parseInt(document.getElementById(`id-safearea-${element.id}`).style.width.replaceAll('px', '')),
        height: parseInt(document.getElementById(`id-safearea-${element.id}`).style.height.replaceAll('px', '')),
        safearea : element.properties.safearea
      });
    }
  }

  function handleMouseMove(e) {
    if (activeTranslate) {
      let masterCopy = master.elements.filter(x => x.dynamic === true);
      masterCopy.forEach(el => {        
        document.getElementById(`id-safearea-${el.id}`).style.pointerEvents = 'none';
      });
      let div = document.getElementById(`id-safearea-${activeTranslate.element.id}`);
      const x = e.clientX - activeTranslate.pos.x;
      const y = e.clientY - activeTranslate.pos.y;
      div.style.top = `${activeTranslate.top + y}px`;
      div.style.left = `${activeTranslate.left + x}px`;
    }
    else if (active) {
      let div = document.getElementById(`id-safearea-${active.element.id}`);
      const x = e.clientX - active.pos.x;
      const y = e.clientY - active.pos.y;
      div.style.width = `${active.width + x}px`;
      div.style.height = `${active.height + y}px`;
    }
  }

  function handleMouseEnd() {
    let copyMaster = JSON.parse(JSON.stringify(master));
    if (activeTranslate) {
      let div = document.getElementById(`id-safearea-${activeTranslate.element.id}`);
      // div.style.pointerEvents = 'auto';
      const index = copyMaster.elements.findIndex(x => x.id === activeTranslate.element.id);
      if (index > -1) {
        copyMaster.elements[index].properties.safearea.top.value = parseInt(div.style.top.replaceAll('px', ''));
        copyMaster.elements[index].properties.safearea.left.value = parseInt(div.style.left.replaceAll('px', ''));
        let newActiveElement = JSON.parse(JSON.stringify(activeElement));
        newActiveElement.properties.safearea.top.value = parseInt(div.style.top.replaceAll('px', ''));
        newActiveElement.properties.safearea.left.value = parseInt(div.style.left.replaceAll('px', ''));
        setActiveElement(newActiveElement);
        setMaster(copyMaster);
      }
      setActiveTranslate(null);
    }
    else if (active) {
      let div = document.getElementById(`id-safearea-${active.element.id}`);
      // div.style.pointerEvents = 'auto';
      const index = copyMaster.elements.findIndex(x => x.id === active.element.id);
      if (index > -1) {
        copyMaster.elements[index].properties.safearea.width.value = parseInt(div.style.width.replaceAll('px', ''));
        copyMaster.elements[index].properties.safearea.height.value = parseInt(div.style.height.replaceAll('px', ''));
        setMaster(copyMaster)
      }
      setActive(null);
    }
    
    let masterCopy = master.elements.filter(x => x.dynamic === true);
    masterCopy.forEach(el => {        
      document.getElementById(`id-safearea-${el.id}`).style.pointerEvents = 'auto';
    });
  }

  const [elementSteps, setElementSteps] = useState([]);

  useEffect(() => {
    console.log('useEffect elementSteps')
    if (!dynamic) return;
    steps = master.elements[master.elements.length - 1]?.step || 0;
    const elements2 = JSON.parse(JSON.stringify(master.elements));
    const newElementSteps = [];
    
    for (let i = 1; i <= steps; i++) {
      let el = elements2.filter(x => x.step === i);
      newElementSteps.push(el);
    }
   
    setElementSteps(newElementSteps);
  }, [master.elements]);

  const htmlSrc = (step) => {
    let html = ConvertBannerDynamic(master, listFonts, step);
    return html
  }

  function handleChangeText(el, e) {
    let copyMaster = JSON.parse(JSON.stringify(master));
    const index = copyMaster.elements.findIndex(x => x.id === el.id);
    if (index > -1) {
      copyMaster.elements[index].properties.text.text = e.target.value;
      setMaster(copyMaster);
    }
  }

  function handleChangeFontSize(el, e) {
    let copyMaster = JSON.parse(JSON.stringify(master));
    const index = copyMaster.elements.findIndex(x => x.id === el.id);
    if (index > -1) {
      copyMaster.elements[index].properties.text.fontSize = e.target.value;
      setMaster(copyMaster);
    }
  }  

  function handleChangeImage(el, e) {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = function(event) {
      let copyMaster = JSON.parse(JSON.stringify(master));
      const index = copyMaster.elements.findIndex(x => x.id === el.id);
      if (index > -1) {
        copyMaster.elements[index].properties.background = event.target.result;
        setMaster(copyMaster);
      }
    };
    reader.readAsDataURL(file);
  }

  return (
    <div className='container-stage'>
      {
        modalDynamic !== "" ? 
        <div 
          style={{
            display: 'flex',
            position: 'absolute',
            top: '-80px',
            left: '-1px',
            width: '100vw',
            height: 'calc(100vh + 10px)',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 999999
          }}
        >
            <div style={{height: '85%', width: '85%', position: 'relative'}}>
              <div style={{display: 'flex', background: '#EFEFEF', width: '100%', height: '50px', display: 'flex', borderRadius: '10px 10px 0 0'}}>
                <span
                  onClick={() => setModalDynamic("Elementos")}
                  style={{
                    cursor: 'pointer',
                    width: '120px',
                    fontSize: '18px',
                    fontWeight: '700',
                    textAlign: 'center',
                    color: modalDynamic === "Elementos" ? 'white' : 'rgba(212, 212, 212, 0.71)',
                    padding: '5px 20px',
                    borderRadius: '10px 10px 0 0',
                    backgroundColor: modalDynamic !== "Elementos" ? 'rgb(107, 107, 107)' : '#1B9ADA',
                }}>
                  Elementos
                </span>
                <span
                  onClick={() => setModalDynamic("Regras")}
                  style={{
                    cursor: 'pointer',
                    width: '120px',
                    fontSize: '18px',
                    fontWeight: '700',
                    textAlign: 'center',
                    color: modalDynamic === "Regras" ? 'white' : 'rgba(212, 212, 212, 0.71)',
                    padding: '5px 20px',
                    borderRadius: '10px 10px 0 0',
                    backgroundColor: modalDynamic !== "Regras" ? 'rgb(107, 107, 107)' : '#1B9ADA',
                  }}>
                  Regras
                </span>
                <span style={{position: 'absolute', right: '15px', top: '6px', fontWeight: 'bold', fontSize: '20px', cursor: 'pointer'}} onClick={() => { setModalDynamic(''); setFullScreenLeft(false);}}>X</span>
              </div>
              <div style={{background: 'white', height: '90%', overflowY: 'scroll', borderRadius: '0px 0px 30px 30px', padding: '20px 80px 20px 80px', flexDirection: 'column'}}>
                {modalDynamic === "Elementos" ?
                  (
                    <div>
                      <div onClick={() => document.getElementById('id-add-fonts').click()} style={{cursor: 'pointer', border: '1px dashed #1B9ADA', width: '100%', height: '100px', borderRadius: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
                        <span style={{color: '#1B9ADA', fontSize: '60px'}}>+</span>
                        <span style={{color: '#1B9ADA'}}>Subir arquivos</span>
                        <span style={{color: '#8d8d8dff', lineHeight: '0.4'}}>(Somente arquivos de fonte)</span>
                        <input
                          type="file"
                          id="id-add-fonts"
                          style={{ display: 'none' }}
                          multiple
                          accept=".woff,.woff2,.ttf"
                          onChange={() => handleAddFonts()}
                        />
                      </div>
                      {
                        <div style={{display: 'flex', flexDirection: 'row', marginTop: '20px', justifyContent: 'center'}}>
                          {
                          elementSteps.map((elStep, i) => (
                            <div style={{padding: '0px 10px 0 40px', display: 'flex', flexDirection: 'column'}}>
                            <span style={{fontWeight: 'bold', color: '#1B9ADA'}}>{`Step ${i + 1}`}</span>
                            {elStep.map((element, i) => (
                              <div key={i} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', position: 'relative', width: '400px', borderBottom: '1px solid #DCDCDC', paddingBottom: '10px', cursor: 'pointer' }}>
                                <div style={{display: 'flex', alignItems: 'center'}}>
                                  <input checked={!!element.dynamic} onChange={() => handleCheckDynamic(element)} type="checkbox" />
                                  <div style={{
                                    width: '60px',
                                    height: '60px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    overflow: 'hidden',
                                    margin: '0 10px 0 10px',
                                    background: '#DCDCDC',
                                    borderRadius: '5px'
                                  }}>
                                    <div style={{width: '40px', height: '40px'}}>
                                      <img
                                        alt="preview"
                                        src={element.properties.blob}
                                        style={{
                                          boxShadow: '1px 2px 5px 1px #444444',
                                          display: 'block',
                                          margin: 'auto',
                                          maxWidth: '100%',
                                          maxHeight: '100%',
                                          height: 'auto',
                                          width: 'auto'
                                        }}></img>
                                    </div>
                                  </div>
                                  <span>{element.id}</span>
                                </div>
                                {listFonts && element.properties.text && element.dynamic && (
                                  <select
                                    style={{ width: '140px', marginLeft: '10px', padding: '4px 8px', borderRadius: '4px', border: '1px solid #ccc', position: 'absolute', right: '20px' }}
                                    defaultValue={ element.properties.text.font ? element.properties.text.font.name : ""}
                                    onChange={e => handleChangeFont(element, e.target.selectedIndex > 0 ? e.target.selectedIndex - 1 : null)}
                                  >
                                    <option value="">-</option>
                                    {listFonts.map((font, idx) => (
                                      <option key={idx} value={font.name}>
                                        {font.name.replace(/\.[^/.]+$/, "")}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </div>
                            ))}
                            </div>
                            ))
                          }
                        </div>
                      }
                    </div>
                  )
                : modalDynamic === "Regras" ?
                <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                  <div style={{display: 'flex', flexDirection: 'row'}}>
                    {
                      elementSteps.map((elStep, i) => (
                      <>
                        <div style={{display: 'flex', alignItems: 'center', flexDirection: 'column'}}>
                          <div style={{display: 'flex', padding: '30px 0', flexDirection: 'column', height: 'calc(100% - 100px)' }}>
                            <span style={{fontWeight: 'bold', color: '#1B9ADA'}}>{`Step ${i + 1}`}</span>
                            <div style={{position: 'relative', width: master.width + "px", height: master.height + "px" }}>
                              <div
                                onMouseMove={(e) => handleMouseMove(e)}
                                onMouseUp={() => handleMouseEnd()}
                                style={{position: 'absolute', width: master.width + "px", height: master.height + "px", border: '1px solid #ccc', zIndex: 100 }}>
                              </div>
                              <div
                                style={{position: 'absolute', width: master.width + "px", height: master.height + "px", border: '1px solid #ccc', background: background ? 'black' : 'white' }}>
                                  <iframe style={{position: 'absolute', width: master.width + "px", height: master.height + "px", userSelect: 'none' }}  srcDoc={htmlSrc(i + 1)}></iframe>
                                {elStep.map((element, i) => (
                                  <>
                                    {element.dynamic && (
                                    <div id={`id-safearea-${element.id}`}
                                      style={{
                                        position: 'absolute',
                                        background: activeElement && activeElement.id === element.id ? '#188bc4ff' : 'transparent' ,
                                        opacity: activeElement && activeElement.id === element.id ? 0.7 : 0.4,
                                        border: activeElement && activeElement.id === element.id ? '1px solid #041117ff' : '1px solid #1B9ADA',
                                        width: `${element.properties.safearea.width.value}px`,
                                        height: `${element.properties.safearea.height.value}px`,
                                        top: `${element.properties.safearea.top.value}px`,
                                        left: `${element.properties.safearea.left.value}px`,
                                        zIndex: 1000,
                                      }}
                                      >
                                        <div style={{
                                            position: 'absolute',
                                            cursor: 'move',
                                            zIndex: 9999999999999999,
                                            width: `${element.properties.safearea.width.value * 0.97}px`,
                                            height: `${element.properties.safearea.height.value}px`,
                                            userSelect: 'none'
                                          }}
                                          onMouseDown={(e) => activeElement && activeElement.id === element.id ? handleTranslate(e, element) : null}
                                          >
                                        </div>
                                        <div
                                          onMouseDown={(e) => activeElement && activeElement.id === element.id ? handleResize(e, element) : null}
                                          style={{display: activeElement && activeElement.id === element.id ? 'flex' : 'none', background: 'white', border: '1px solid #1B9ADA', zIndex: 9999999999999999, userSelect: 'none', cursor: 'nw-resize', width: '5px', height: '5px', borderRadius: '1px', position: 'absolute', top: element.properties.safearea.height.value - 1, left: element.properties.safearea.width.value - 2}}>
                                      </div>
                                      {
                                        activeOver === `id-safearea-${element.id}` ?
                                        <div style={{display: 'flex', flexDirection: 'column', position: 'absolute', bottom: '-22px', right: '4px', background: 'white'}}>
                                          <span style={{fontSize: '10px',lineHeight: '1'}}>{`W/H: (${element.properties.safearea.width.value}x${element.properties.safearea.height.value})px`}</span>
                                          <span style={{fontSize: '10px',lineHeight: '1'}}>{`T/L: (${element.properties.safearea.top.value}x${element.properties.safearea.left.value})px`}</span>
                                        </div>
                                        : <></>
                                      }
                                      <div></div>
                                    </div>
                                  )}
                                  </>
                                ))}
                              </div>
                            </div>
                          </div>                        
                          {
                            <div
                              style={{
                                display: 'flex', 
                                flexDirection: 'column', 
                                alignItems: 'center'}}>
                              <>
                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>
                                  <svg style={{cursor: 'pointer', opacity: activeElement && activeElement.properties && activeElement.properties.safearea && activeElement.properties.safearea.align && activeElement.properties.safearea.align.horizontal && activeElement.properties.safearea.align.horizontal === 'left' ? 1 : 0.5}} onClick={() => handleChangeAlign('horizontal', 'left')} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <g id="Group_4757" data-name="Group 4757" transform="translate(-679.617 -988)">
                                      <g id="Rectangle_334" data-name="Rectangle 334" transform="translate(679.617 988)" fill="#f5f5fa" stroke="#1b9ada" stroke-width="2">
                                        <rect width="30" height="30" rx="5" stroke="none"/>
                                        <rect x="1" y="1" width="28" height="28" rx="4" fill="none"/>
                                      </g>
                                      <g id="Group_4756" data-name="Group 4756" transform="translate(5)">
                                        <rect id="Rectangle_147713" data-name="Rectangle 147713" width="4" height="20" rx="2" transform="translate(679.617 993)" fill="#1b9ada"/>
                                        <rect id="Rectangle_147714" data-name="Rectangle 147714" width="4" height="15" rx="2" transform="translate(700.617 997) rotate(90)" fill="#1b9ada"/>
                                        <rect id="Rectangle_147715" data-name="Rectangle 147715" width="4" height="12" rx="2" transform="translate(697.617 1006) rotate(90)" fill="#1b9ada"/>
                                      </g>
                                    </g>
                                  </svg>

                                  <svg style={{cursor: 'pointer', opacity: activeElement && activeElement.properties && activeElement.properties.safearea && activeElement.properties.safearea.align && activeElement.properties.safearea.align.horizontal && activeElement.properties.safearea.align.horizontal === 'center' ? 1 : 0.5}} onClick={() => handleChangeAlign('horizontal', 'center')}  xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <g id="Group_4758" data-name="Group 4758" transform="translate(-679.617 -988)">
                                      <g id="Rectangle_334" data-name="Rectangle 334" transform="translate(679.617 988)" fill="#f5f5fa" stroke="#1b9ada" stroke-width="2">
                                        <rect width="30" height="30" rx="5" stroke="none"/>
                                        <rect x="1" y="1" width="28" height="28" rx="4" fill="none"/>
                                      </g>
                                      <g id="Group_4760" data-name="Group 4760">
                                        <rect id="Rectangle_147713" data-name="Rectangle 147713" width="4" height="20" rx="2" transform="translate(692.617 993)" fill="#1b9ada"/>
                                        <rect id="Rectangle_147714" data-name="Rectangle 147714" width="4" height="15" rx="2" transform="translate(702.617 997) rotate(90)" fill="#1b9ada"/>
                                        <rect id="Rectangle_147715" data-name="Rectangle 147715" width="4" height="12" rx="2" transform="translate(700.617 1006) rotate(90)" fill="#1b9ada"/>
                                      </g>
                                    </g>
                                  </svg>

                                  <svg style={{cursor: 'pointer', opacity: activeElement && activeElement.properties && activeElement.properties.safearea && activeElement.properties.safearea.align && activeElement.properties.safearea.align.horizontal && activeElement.properties.safearea.align.horizontal === 'right' ? 1 : 0.5}} onClick={() => handleChangeAlign('horizontal', 'right')} xmlns="http://www.w3.org/2000/svg" id="Group_4759" data-name="Group 4759" width="30" height="30" viewBox="0 0 30 30">
                                    <g id="Rectangle_334" data-name="Rectangle 334" fill="#f5f5fa" stroke="#1b9ada" stroke-width="2">
                                      <rect width="30" height="30" rx="5" stroke="none"/>
                                      <rect x="1" y="1" width="28" height="28" rx="4" fill="none"/>
                                    </g>
                                    <g id="Group_4756" data-name="Group 4756" transform="translate(4 5)">
                                      <rect id="Rectangle_147713" data-name="Rectangle 147713" width="4" height="20" rx="2" transform="translate(17)" fill="#1b9ada"/>
                                      <rect id="Rectangle_147714" data-name="Rectangle 147714" width="4" height="15" rx="2" transform="translate(15 4) rotate(90)" fill="#1b9ada"/>
                                      <rect id="Rectangle_147715" data-name="Rectangle 147715" width="4" height="12" rx="2" transform="translate(15 13) rotate(90)" fill="#1b9ada"/>
                                    </g>
                                  </svg>
                                  
                                </div>
                                <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>
                                  <svg style={{cursor: 'pointer', opacity: activeElement && activeElement.properties && activeElement.properties.safearea && activeElement.properties.safearea.align && activeElement.properties.safearea.align.vertical && activeElement.properties.safearea.align.vertical === 'bottom' ? 1 : 0.5}} onClick={() => handleChangeAlign('vertical', 'bottom')} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <g id="Group_4763" data-name="Group 4763" transform="translate(-988 709.617) rotate(-90)">
                                      <g id="Rectangle_334" data-name="Rectangle 334" transform="translate(679.617 988)" fill="#f5f5fa" stroke="#1b9ada" stroke-width="2">
                                        <rect width="30" height="30" rx="5" stroke="none"/>
                                        <rect x="1" y="1" width="28" height="28" rx="4" fill="none"/>
                                      </g>
                                      <g id="Group_4756" data-name="Group 4756" transform="translate(5)">
                                        <rect id="Rectangle_147713" data-name="Rectangle 147713" width="4" height="20" rx="2" transform="translate(679.617 993)" fill="#1b9ada"/>
                                        <rect id="Rectangle_147714" data-name="Rectangle 147714" width="4" height="15" rx="2" transform="translate(700.617 997) rotate(90)" fill="#1b9ada"/>
                                        <rect id="Rectangle_147715" data-name="Rectangle 147715" width="4" height="12" rx="2" transform="translate(697.617 1006) rotate(90)" fill="#1b9ada"/>
                                      </g>
                                    </g>
                                  </svg>

                                  <svg style={{cursor: 'pointer', opacity: activeElement && activeElement.properties && activeElement.properties.safearea && activeElement.properties.safearea.align && activeElement.properties.safearea.align.vertical && activeElement.properties.safearea.align.vertical === 'center' ? 1 : 0.5}} onClick={() => handleChangeAlign('vertical', 'center')} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <g id="Group_4762" data-name="Group 4762" transform="translate(-988 709.617) rotate(-90)">
                                      <g id="Rectangle_334" data-name="Rectangle 334" transform="translate(679.617 988)" fill="#f5f5fa" stroke="#1b9ada" stroke-width="2">
                                        <rect width="30" height="30" rx="5" stroke="none"/>
                                        <rect x="1" y="1" width="28" height="28" rx="4" fill="none"/>
                                      </g>
                                      <g id="Group_4760" data-name="Group 4760">
                                        <rect id="Rectangle_147713" data-name="Rectangle 147713" width="4" height="20" rx="2" transform="translate(692.617 993)" fill="#1b9ada"/>
                                        <rect id="Rectangle_147714" data-name="Rectangle 147714" width="4" height="15" rx="2" transform="translate(702.617 997) rotate(90)" fill="#1b9ada"/>
                                        <rect id="Rectangle_147715" data-name="Rectangle 147715" width="4" height="12" rx="2" transform="translate(700.617 1006) rotate(90)" fill="#1b9ada"/>
                                      </g>
                                    </g>
                                  </svg>


                                  <svg style={{cursor: 'pointer', opacity: activeElement && activeElement.properties && activeElement.properties.safearea && activeElement.properties.safearea.align && activeElement.properties.safearea.align.vertical && activeElement.properties.safearea.align.vertical === 'top' ? 1 : 0.5}} onClick={() => handleChangeAlign('vertical', 'top')}  xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                                    <g id="Group_4761" data-name="Group 4761" transform="translate(0 30) rotate(-90)">
                                      <g id="Rectangle_334" data-name="Rectangle 334" fill="#f5f5fa" stroke="#1b9ada" stroke-width="2">
                                        <rect width="30" height="30" rx="5" stroke="none"/>
                                        <rect x="1" y="1" width="28" height="28" rx="4" fill="none"/>
                                      </g>
                                      <g id="Group_4756" data-name="Group 4756" transform="translate(4 5)">
                                        <rect id="Rectangle_147713" data-name="Rectangle 147713" width="4" height="20" rx="2" transform="translate(17)" fill="#1b9ada"/>
                                        <rect id="Rectangle_147714" data-name="Rectangle 147714" width="4" height="15" rx="2" transform="translate(15 4) rotate(90)" fill="#1b9ada"/>
                                        <rect id="Rectangle_147715" data-name="Rectangle 147715" width="4" height="12" rx="2" transform="translate(15 13) rotate(90)" fill="#1b9ada"/>
                                      </g>
                                    </g>
                                  </svg>

                                </div>
                              </>
                              
                            </div>
                          }
                        </div>                        
                        <div style={{display: 'flex', flexDirection :'column', gap: '15px',  margin: '60px 50px 0px 15px'}}>
                          {
                            elStep.filter(x => x.dynamic).map((el, i) => (
                              <div style={{display: 'flex', flexDirection: 'column', gap: '10px', cursor: 'pointer' }} onClick={() => setActiveElement(el)}>
                                <span style={{
                                  textDecoration: activeElement && activeElement.id === el.id ? 'underline' : '',
                                  color: activeElement && activeElement.id === el.id ?  'red' : '#707070',
                                  textAlign: 'left', font: 'italic normal bold 16px/21px Segoe UI', marginLeft: '10px'}}>{el.id}</span>
                                  {el && el.properties && el.properties.text ?
                                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                      <input style={{color:'rgb(112, 112, 112)', width: '169px', height: '25px', borderRadius: '4px', border: '1px solid #707070'}} onBlur={(e) => handleChangeText(el, e)} defaultValue={el && el.properties && el.properties.text ? el.properties.text.text : ''}></input>
                                      <div style={{display: 'flex',  flexDirection: 'column', position: 'relative'}}>                                        
                                        <span style={{
                                          width: '70px',
                                          position: 'absolute',
                                          top: '-30px',
                                          color: '#707070',
                                          textAlign: 'left', font: 'italic normal bold 16px/21px Segoe UI', marginLeft: '10px'}}>Font-Size</span>
                                        <input style={{marginLeft: '10px', color:'rgb(112, 112, 112)', width: '50px', height: '25px', borderRadius: '4px', border: '1px solid #707070'}} onBlur={(e) => handleChangeFontSize(el, e)}  defaultValue={el && el.properties && el.properties.text ? parseInt(el.properties.text.fontSize) : ''}></input>
                                      </div>
                                    </div>
                                    :
                                    <div style={{display: 'flex'}}>
                                      <div style={{width: '169px', height: '25px', borderRadius: '4px', border: '1px solid #707070', position: 'relative', display: 'flex', alignItems: 'center'}}>
                                        <span style={{marginLeft: '5px', color: '#707070'}}>image</span>
                                        <svg className='button-change-image' xmlns="http://www.w3.org/2000/svg" width="19.698" height="19.698" viewBox="0 0 19.698 19.698" onClick={() => document.getElementById(`id-input-image-${el.id}`).click()}>
                                          <g id="Group_4766" data-name="Group 4766" transform="translate(-1979.117 -917.864)">
                                            <rect id="Rectangle_246" data-name="Rectangle 246" width="19.698" height="19.698" rx="4" transform="translate(1979.117 917.864)" fill="#1b9ada"/>
                                            <path id="Africa" d="M14.339-5.6H9.774v4.566h-2.4V-5.6H2.789V-8.008H7.378V-12.6h2.4v4.589h4.566Z" transform="translate(1980.401 934.529)" fill="#fff"/>
                                          </g>
                                        </svg>
                                      </div>
                                        {
                                          activeElement && activeElement.properties && activeElement.properties.safearea ?
                                          <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', position: 'relative', width: '60px'}}>
                                            <div style={{position: 'absolute', top: '-5px',}}>
                                              <span style={{position: 'absolute', top: '-30px', fontWeight: 'bold'}}>Contain</span>
                                              <Switch onChange={(evt) => handleChangeContain(evt)} defaultChecked={activeElement ? activeElement.properties.safearea.contain : false} {...{ inputProps: { 'aria-label': 'Switch demo' } }} />
                                            </div>
                                          </div>
                                        : null
                                        }
                                      <input accept=".png,.img,image/png,image/img" style={{display: 'none'}} id={`id-input-image-${el.id}`} onChange={(e) => handleChangeImage(el, e)} type='file'></input>
                                    </div>
                                  }
                              </div>
                            ))
                          }
                        </div>
                      </>
                    ))
                  }
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '30px', gap: '60px'}}>
                      <button className='uploadButton'>Fechar</button>
                      <button className='downloadButton' onClick={() => handleClickDownloadDynamic()}>Salvar</button>
                    </div>
                  </div> :
                <></>
                }
              </div>
          </div>
        </div>
        : <></>
      }
      <div className='collapseAnimation'
        style= {{
        right: fullScreenRight ? '-6px' : '-10px',
        transform: fullScreenRight ? 'scaleX(1)' : 'scaleX(-1)',
        transition: 'right 500ms', 
        }}
        onClick={() => setFullScreenRight(!fullScreenRight)}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
          <g id="Group_733" data-name="Group 733" transform="translate(-5890 9764)">
            <g id="Ellipse_33" data-name="Ellipse 33" transform="translate(5890 -9764)" fill="#1B9ADA" stroke="#1B9ADA" stroke-width="1">
              <circle cx="10" cy="10" r="10" stroke="none"/>
              <circle cx="10" cy="10" r="9.5" fill="none"/>
            </g>
            <path id="Path_538" data-name="Path 538" d="M0,0,4.5,5.143,9,0" transform="translate(5901.665 -9758.474) rotate(90)" fill="none" stroke="#FFFFFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          </g>
        </svg>
      </div>
      <div
        id="backup-img-master"
        style={{
          zIndex: -1,
          display: 'none',
          width: `${master.width}px`,
          height: `${master.height}px`,
          position: 'absolute',
          background: master.backgroundColor,
          top: '0px',
          left: '0px'
          }}
        >
        {elements.map(item =>
          item.stepout > steps || item.fixo ?
          <div
            key={Math.random()}
            style={{
              width: `${Math.ceil(item.properties.width * item.properties.scale / 100)}px`,
              height: `${Math.ceil(item.properties.height * item.properties.scale / 100)}px`,
              background: item.properties.blob ? `url('${item.properties.blob}') no-repeat`: "",
              position: 'absolute',
              top: `${item.properties.top}px`,
              left: `${item.properties.left}px`,
              zIndex: `${item.properties.zIndex === 999 ? 999 :item.stepout > steps ? 998 : item.fixo ? 997 : item.properties.zIndex}`,
              backgroundSize: 'cover'
            }}>
          </div> :  <></>
        )}
      </div>
      <div className='stageTop'>
        <span className='fileName' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          { master.psd ? master.psd.replace(/\.[^/.]+$/, "") : "" }
        </span>
        <div className='containerButtons'>
          <button onClick={handleWindowUp} className='uploadButton'>Upload <DownloadIcon style={{transform: 'rotate(180deg)', margin: '0 -5px 0 10px'}} /></button>
              {isWindowUpOpen && (
                <div ref={windowRef} className='uploadWindow'>
                  <div onClick={handleClickUpdatePSD} className='updatePSD'><ReplayIcon className='replayIcon'/> Atualizar PSD</div>
                  <button onClick={() => refInput.current.click()} className='loadSeed'><AnimationIcon className='animationIcon'/> Carregar Seed</button>
                  <input 
                    onClick={() => refInput.current.click()}
                    onChange={() => carregarSeed()}
                    type='file'
                    ref={refInput}
                    id='file-rean-seed'
                    style={{display: 'none'}}
                  />
                </div>
              )}
            <button onClick={handleWindowDown} className='downloadButton'>Download <DownloadIcon style={{margin: '0 -5px 0 10px'}}/></button>
            {isWindowDownOpen && (
              <div ref={windowRef} className='downloadWindow'>
                <div onClick={handleClickDownloadRean} className='downRean'><FlashOnIcon className='flashIcon'/> Re.animate</div>
                <div onClick={handleClickDownloadHTML} className='downHTML'><CodeIcon className='codeIcon'/> Pack HTML</div>
                {/* <div onClick={handleClickDownloadDynamic} className='downHTML'><CodeIcon className='codeIcon'/> Pack Dynamic</div> */}
                <div onClick={handleClickDownloadImg} className='downImg'><CropOriginalIcon className='cropIcon'/> Pack Imagem</div>
                <div onClick={handleClickDownloadVid} className='downVid'><VideocamIcon className='videoIcon'/> Video (BETA)</div>
                {
                  dynamic ?
                  <div onClick={() => {
                    setModalDynamic("Elementos");
                    setFullScreenLeft(true);
                  }} className='downVid'><FlashOnIcon className='videoIcon'/>Dynamic</div>
                  : <></>
                }
                
              </div>
            )}
        </div>
      </div>
      <div className='container-a'>
        <div style={{width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <div style={{display: 'flex', flexDirection: 'column', width: 'calc(100% - 400px)', overflow: 'auto', height: '100%', justifyContent: 'center', alignItems: 'center', overflowX: 'hidden'}}>
            <div id="stage-banner-id" style={{overflow: zoomFit ? 'hidden' : 'auto', display: 'flex', alignItems: 'center', marginRight: '-130px'}}>
            <iframe style={{transform: 'scale(' + zoom / 100 +')', border: 'none'}} title="iframeMaster" ref={refIframeMaster} id='iframeMaster' onLoad={() => LoadIframe()}></iframe>
            </div>
          </div>
          <div className="preset-play-button" onClick={() => setReload(true)} style={{transition: 'opacity 250ms', opacity: '0',  width: '50px', height: '50px', borderRadius: '50px', position: 'absolute', bottom: '90px'}}>
            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" 
              width="30" height="30" viewBox="0 0 11.718 17.411">
              <defs>
                <clipPath id="clip-path">
                  <rect id="Retângulo_44" dataname="Retângulo 44" width="30" height="30 " fill="#1b9ada"/>
                </clipPath>
              </defs>
              <g id="Grupo_113" dataname="Grupo 113" clipPath="url(#clip-path)">
                <path id="Caminho_152" dataname="Caminho 152" d="M0,1.93V15.481c0,1.717,2.288,2.576,3.626,1.363l7.47-6.776a1.8,1.8,0,0,0,0-2.724L3.626.568C2.288-.645,0,.214,0,1.93" transform="translate(0 0)"/>
              </g>
            </svg>
          </div>
        </div>

        <div className='containerZoom'>
          <div style={{display: 'flex', alignItems: 'center', margin: '0 0 0 0'}}>
            <svg style={{margin: '-4px 5px 0 0'}} id="ico_lupa" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="16.87" height="16.871" viewBox="0 0 16.87 16.871">
              <defs>
                <clipPath id="clip-path">
                  <rect id="Retângulo_37" dataname="Retângulo 37" width="16.87" height="16.871" transform="translate(0 0)" fill="#1b9ada"/>
                </clipPath>
              </defs>
              <g id="Grupo_95" dataname="Grupo 95" transform="translate(0 0)" clipPath="url(#clip-path)">
                <path id="Caminho_155" dataname="Caminho 155" d="M1.658,16.586l4.19-4.192a6.9,6.9,0,1,0-1.371-1.372L.285,15.213a.971.971,0,0,0,1.373,1.373m4.823-13.2a4.95,4.95,0,1,1,0,7,4.956,4.956,0,0,1,0-7" fill="#1b9ada"/>
              </g>
            </svg>
            <Box sx={{ width: 120 }}>
              <Slider
                aria-label="Temperature"
                defaultValue={100}
                min={10}
                getAriaValueText={(evt) => ChangeZoom(evt)}
                color="secondary"
              />
            </Box>
          </div>
          <span className='percentZoom'>{zoom}% </span>
        </div>
        <div style={{width: '130px', display: 'flex', justifyContent: 'end'}}>
        <Copilot/>
        </div>

      </div>
    </div>
  )
}

export default Stage;